/**
 * Jovii — a poster's bytes, for the downloads that keep one.
 *
 * Lives here and not in lib/offline on purpose: that directory is gated by
 * client-only.test.ts to contain no `fetch(` at all, so that media bytes can
 * only ever travel through RangeReader and never through a bare request that
 * would relay a film through the service. A poster is a 40 KB catalogue image
 * from Cinemeta's CDN, not media - but the gate cannot tell, and it is right
 * not to try. So the request is made here and only the BYTES cross into the
 * store.
 */
import { savePoster } from '$lib/offline/store';

export async function keepPoster(key: string, url: string): Promise<void> {
  try {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) return;
    await savePoster(key, new Uint8Array(await res.arrayBuffer()));
  } catch {
    /* no poster on the disk; the row keeps its initial */
  }
}
